<template>
  <div>
    <v-container fluid>
      <v-layout class="mb-2">
        <v-flex v-if="isPowerbuyPage">
          <div
            class="nav nav-tabs"
            style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
          >
            <v-btn
              depressed
              class="ma-1"
              :outline="filterApp != 'all'"
              :color="filterApp != 'all' ? 'grey' : 'primary'"
              @click="filterApp = 'all'"
            >
              {{ $t('All') }}
            </v-btn>
            <v-btn
              depressed
              class="ma-1"
              :outline="filterApp != 'facebook'"
              :color="filterApp != 'facebook' ? 'grey' : 'primary'"
              @click="filterApp = 'facebook'"
            >
              <em class="fab fa-facebook-square mr-1" />
              {{ $t('facebook') }}
            </v-btn>
            <v-btn
              depressed
              class="ma-1"
              :outline="filterApp != 'line'"
              :color="filterApp != 'line' ? 'grey' : 'primary'"
              @click="filterApp = 'line'"
            >
              <em class="fab fa-line mr-1" />
              {{ $t('line') }}
            </v-btn>
            <v-btn
              depressed
              class="ma-1"
              :outline="filterApp != 'instagram'"
              :color="filterApp != 'instagram' ? 'grey' : 'primary'"
              @click="filterApp = 'instagram'"
            >
              <em class="fab fa-instagram mr-1" />
              {{ $t('instagram') }}
            </v-btn>
          </div>
        </v-flex>
        <v-flex v-if="isTcpMainPage">
          <multiselect
            v-model="filterTcpPage"
            :options="tcpPageOptions"
            select-label
            selected-label
            placeholder="เลือกเพจ"
            label="page_name"
            style="margin-bottom: 4px"
            @input="handleFetchTcpBusinessSummary"
          ></multiselect>
        </v-flex>

        <v-flex class="text-xs-right">
          <v-btn
            v-if="$store.getters.getPackage != 'premium'"
            v-tooltip.top="'Unlock to PREMIUM plan'"
            outline
            color="grey"
            :loading="loading"
          >
            <em class="fas fa-file-export mr-1" /> {{ $t('export') }}
            <v-premium-lock></v-premium-lock
          ></v-btn>
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            color="primary"
            outline
            class="ma-0 mb-1"
            :loading="loading"
            @click="exportData"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <DashboardSelectChannel v-model="filterApp" @changeChannel="handleFetchData()" />

      <date-filter
        v-model="selectedDate"
        :show-time="true"
        @onSelected="handleFetchData"
      ></date-filter>

      <div v-if="isPowerbuyPage" class="py-3">
        <multiselect
          v-model="filterShop"
          placeholder="เลือกสาขา"
          label="branch"
          :options="powerbuyShopOptions"
          :show-labels="false"
          style="max-width: 300px"
          @input="handleChangeShop"
        ></multiselect>
      </div>
      <div class="my-3">
        <v-layout row wrap>
          <v-flex xs12 lg3 class="pl-1">
            <v-card height="100%" class="pa-0">
              <v-card-text class="pb-1 statscard">
                <p class="mb-0">{{ $t('Total Orders') }}</p>
                <h1 class="headline text-xs-right mr-2">{{ totalorder | numberFormat }}</h1>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 lg9>
            <v-layout row wrap class="mb-0">
              <v-flex xs12 lg4 class="pl-1">
                <v-card height="100%" class="pa-0">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Total Sales') }}</p>
                    <h1 class="headline text-xs-right mr-2">{{ totalamount | numberFormat }}</h1>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 lg4 class="pl-1">
                <v-card height="100%" class="pa-0">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Total Sales (without Shipping Charge)') }}</p>
                    <h1 class="headline text-xs-right mr-2">
                      {{ (totalamount - totalshippingcharge) | numberFormat }}
                    </h1>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex lg4 xs12 class="pl-1">
                <v-card height="100%" class="pa-0">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Total Shipping Charge') }}</p>
                    <h1 class="headline text-xs-right mr-2">
                      {{ totalshippingcharge | numberFormat }}
                    </h1>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4 class="pt-1 pl-1">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Avg Sales / 1 Order') }}</p>
                    <h1 class="headline text-xs-right mr-2 mt-0 mb-1">
                      {{ (totalamount / totalorder) | numberFormat }}
                    </h1>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4 class="pt-1 pl-1">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Avg Sales (without Shipping Charge) / 1 Order') }}</p>
                    <h1 class="headline text-xs-right mr-2 mt-0 mb-1">
                      {{ ((totalamount - totalshippingcharge) / totalorder) | numberFormat }}
                    </h1>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4 class="pt-1 pl-1">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Avg Shipping Charge / 1 Order') }}</p>
                    <h1 class="headline text-xs-right mr-2 mt-0 mb-1">
                      {{ (totalshippingcharge / totalorder) | numberFormat }}
                    </h1>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <h3 class="headline">{{ $t('Best seller') }}</h3>
      <v-data-table
        expand
        :loading="loading"
        :pagination.sync="pagination"
        :headers="headers"
        :items="products"
        class="elevation-1 scgallrenttable"
      >
        <template #items="props">
          <tr>
            <td class="text-xs-center" style="position: relative">
              {{ props.index + 1 }}
              <img
                v-if="props.index == 0"
                src="/static/img/assets/shop/crown1.png"
                style="width: 25px; position: absolute; margin-left: -12px; left: 50%; top: -10px"
              />
              <img
                v-if="props.index == 1"
                src="/static/img/assets/shop/crown2.png"
                style="width: 25px; position: absolute; margin-left: -12px; left: 50%; top: -10px"
              />
              <img
                v-if="props.index == 2"
                src="/static/img/assets/shop/crown3.png"
                style="width: 25px; position: absolute; margin-left: -12px; left: 50%; top: -10px"
              />
            </td>
            <td class="text-xs-center">
              {{ props.item.productname ? props.item.productname : $t('All Deleted Products') }}
            </td>
            <td class="text-xs-center">{{ props.item.totalquantity | numberFormat }}</td>
            <td class="text-xs-center">{{ props.item.totalamount | numberFormat }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DashboardSelectChannel from '@/components/view/dashboard/DashboardSelectChannel.vue'
import DateFilter from '@/components/view/dashboard/DateFilter'
import XLSX from 'xlsx'
import numeral from 'numeral'
import { PAGE } from '@/constants/page.js'
import Multiselect from 'vue-multiselect'
import tcpApi from '@/api/tcp'

export default {
  components: {
    DashboardSelectChannel,
    DateFilter,
    Multiselect
  },
  data() {
    return {
      loading: false,
      totalamount: '',
      totalshippingcharge: '',
      totalorder: '',
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      headers: [
        {
          text: 'No.',
          width: '1%',
          align: 'left',
          sortable: false
        },
        {
          text: this.$t('Product Name'),
          value: 'productname',
          align: 'center'
        },
        {
          text: this.$t('Quantity'),
          value: 'totalquantity',
          align: 'center',
          width: '1%'
        },
        {
          text: this.$t('Sales'),
          value: 'totalamount',
          align: 'center',
          width: '2%'
        }
      ],
      products: [],
      filterApp: 'all',
      filterShop: null,
      filterTcpPage: '',
      tcpCurrentPage: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    isPowerbuyPage() {
      return this.selectedBot.theme === 'powerbuy'
    },
    powerbuyShopOptions() {
      return this.$store.state.powerbuyBranchList
    },
    tcpPageOptions() {
      return this.$store.state.tcpSubpages || []
    },
    isTcpMainPage() {
      return PAGE.TCP_MAIN_PAGE.includes(this.selectedBot.pageid)
    },
    isTcpSubpage() {
      return PAGE.TCP_SHOP_SERVICES.includes(this.selectedBot.pageid)
    }
  },
  mounted() {
    if (this.isTcpMainPage && !this.$store.state.tcpSubpages) {
      this.$store.dispatch('getTcpSubpages')
    }

    this.handleFetchData()
  },
  methods: {
    handleFetchData(date) {
      if (this.isTcpMainPage || this.isTcpSubpage) {
        this.handleFetchTcpBusinessSummary()
      } else {
        this.getDashbroadShopAnalytic(date)
      }
    },
    getDashbroadShopAnalytic(date) {
      this.loading = true
      let data = {}
      if (date) {
        data = {
          pageid: this.selectedBot.pageid,
          datefrom: date.start,
          dateto: date.end,
          app: this.filterApp
        }
      } else {
        data = {
          pageid: this.selectedBot.pageid,
          datefrom: this.selectedDate.start,
          dateto: this.selectedDate.end,
          app: this.filterApp
        }
      }

      if (this.isPowerbuyPage && this.filterShop) {
        Object.assign(data, {
          shop_main_pageid: this.filterShop.shop_main_pageid
        })
      }

      api.getdashbroadshopanalytic(data, (error, response) => {
        this.loading = false
        if (response && response.responsecode == 200 && response.data) {
          this.products = response.data2
          this.totalamount = response.data.totalamount
          this.totalshippingcharge = response.data.totalshippingcharge
          this.totalorder = response.data.totalorder
        } else {
          this.products = []
          this.totalamount = 0
          this.totalshippingcharge = 0
          this.totalorder = 0
        }
      })
    },
    exportData() {
      const vm = this
      try {
        if (vm.loading) {
          return false
        }

        const json = []
        json.push([
          `${vm.$t('from')} ` +
            moment(vm.selectedDate.start).format('DD/MM/YYYY') +
            ` ${vm.$t('to')} ` +
            moment(vm.selectedDate.end).format('DD/MM/YYYY')
        ])

        if (vm.isTcpMainPage || vm.tcpSubpages) {
          json.push(['เพจ', vm.filterTcpPage ? vm.filterTcpPage.page_name : vm.tcpCurrentPage])
        } else {
          json.push([])
        }

        json.push([vm.$t('Sales Report')])

        json.push([vm.$t('Total Orders'), numeral(vm.totalorder).format('0,0')])
        json.push([vm.$t('Total Sales'), numeral(vm.totalamount).format('0,0')])
        json.push([
          vm.$t('Total Sales (without Shipping Charge)'),
          numeral(vm.totalamount - vm.totalshippingcharge).format('0,0')
        ])
        json.push([vm.$t('Total Shipping Charge'), numeral(vm.totalshippingcharge).format('0,0')])
        json.push([
          vm.$t('Avg Sales / 1 Order'),
          numeral(vm.totalamount / vm.totalorder).format('0,0')
        ])
        json.push([
          vm.$t('Avg Sales (without Shipping Charge) / 1 Order'),
          numeral((vm.totalamount - vm.totalshippingcharge) / vm.totalorder).format('0,0')
        ])
        json.push([
          vm.$t('Avg Shipping Charge / 1 Order'),
          numeral(vm.totalshippingcharge / vm.totalorder).format('0,0')
        ])

        const wb = XLSX.utils.book_new()
        wb.Props = {
          Title: 'Zwiz Sales Report',
          Subject: 'Sales Report',
          Author: 'Zwiz',
          CreatedDate: moment()
        }
        wb.SheetNames.push('Overall')
        const ws = XLSX.utils.aoa_to_sheet(json)
        wb.Sheets['Overall'] = ws
        wb.SheetNames.push('Products')
        const header = [vm.$t('Product Name'), vm.$t('Quantity'), vm.$t('Sales')]
        let products = vm.products.map((el) => {
          return [
            el.productname ? el.productname : vm.$t('All Deleted Products'),
            numeral(el.totalquantity).format('0,0'),
            numeral(el.totalamount).format('0,0')
          ]
        })
        products.unshift(header)
        const ws2 = XLSX.utils.aoa_to_sheet(products)
        wb.Sheets['Products'] = ws2

        XLSX.writeFile(wb, 'zwiz-salesreport.xlsx')
      } catch (error) {
        console.error(error)
      }
    },
    handleChangeChannel(item) {
      this.app = item
    },
    handleChangeShop() {
      this.getDashbroadShopAnalytic()
    },
    async handleFetchTcpBusinessSummary() {
      const vm = this
      try {
        const data = {
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD')
        }

        if (vm.isTcpMainPage) {
          Object.assign(data, {
            master_page_id: vm.selectedBot.pageid,
            page_id: vm.filterTcpPage ? vm.filterTcpPage.page_id : vm.selectedBot.pageid
          })
        } else {
          Object.assign(data, {
            page_id: vm.selectedBot.pageid
          })
        }
        vm.$store.dispatch('loading')
        const responseChart = await vm.getTcpBusinessSummaryChart(data)
        const responseProductList = await vm.getTcpBusinessSummaryProductList(data)
        vm.$store.commit('CLEAR_LOADING')

        if (
          responseChart &&
          responseChart.status === 200 &&
          responseChart.data &&
          responseChart.data.data
        ) {
          vm.totalamount = responseChart.data.data.amount
          vm.totalshippingcharge = responseChart.data.data.shppingcharge
          vm.totalorder = responseChart.data.data.total_orders
          vm.tcpCurrentPage = responseChart.data.data.page_name
        }

        if (
          responseProductList &&
          responseProductList.status === 200 &&
          responseChart.data &&
          responseChart.data.data
        ) {
          const tempData = responseProductList.data.data
          const products = tempData.map((product) => {
            return {
              productname: product.product_name,
              totalquantity: product.quantity,
              totalamount: product.amount
            }
          })
          vm.products = products
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async getTcpBusinessSummaryChart(payload) {
      try {
        const response = tcpApi.postGetBusinessSummaryChart({ data: payload })
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async getTcpBusinessSummaryProductList(payload) {
      try {
        const response = tcpApi.postGetBusinessSummaryProductList({ data: payload })
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>

<style>
/* .scgallrenttable .v-table__overflow .v-datatable.v-table.theme--light thead tr th {
  padding: 0 !important;
  text-align: center;
} */
.statscard {
  display: flex;
  justify-content: space-between;
  height: 100%;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductAnalytics.vue